/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateSeasonRequest,
  GetSeasonResponse,
  PaginatedResultOfGetSeasonResponse,
  Result,
  ResultOfCreateSeasonResponse,
  SearchQueryRequest,
  UpdateSeasonRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateSeasonRequestFromJSON,
    CreateSeasonRequestToJSON,
    GetSeasonResponseFromJSON,
    GetSeasonResponseToJSON,
    PaginatedResultOfGetSeasonResponseFromJSON,
    PaginatedResultOfGetSeasonResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateSeasonResponseFromJSON,
    ResultOfCreateSeasonResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    UpdateSeasonRequestFromJSON,
    UpdateSeasonRequestToJSON,
} from '../models/index';

export interface ApiSeasonsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiSeasonsPostRequest {
    createSeasonRequest: CreateSeasonRequest;
    xTenantID?: number;
}

export interface ApiSeasonsPutRequest {
    updateSeasonRequest: UpdateSeasonRequest;
    xTenantID?: number;
}

export interface ApiSeasonsScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiSeasonsSearchPostRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

export interface ApiSeasonsSeasonIdDiscountsPutRequest {
    seasonId: number;
    requestBody: Array<string>;
    xTenantID?: number;
}

export interface GetSeasonByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class SeasonsApi extends runtime.BaseAPI {

    /**
     * Deletes a season by its ID. Returns 204 No Content on success, 409 Conflict if the season has associated classes, or 500 Internal Server Error for other failures.
     * Delete season
     */
    async apiSeasonsIdDeleteRaw(requestParameters: ApiSeasonsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiSeasonsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a season by its ID. Returns 204 No Content on success, 409 Conflict if the season has associated classes, or 500 Internal Server Error for other failures.
     * Delete season
     */
    async apiSeasonsIdDelete(requestParameters: ApiSeasonsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSeasonsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new season
     * Creates a new season
     */
    async apiSeasonsPostRaw(requestParameters: ApiSeasonsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateSeasonResponse>> {
        if (requestParameters['createSeasonRequest'] == null) {
            throw new runtime.RequiredError(
                'createSeasonRequest',
                'Required parameter "createSeasonRequest" was null or undefined when calling apiSeasonsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSeasonRequestToJSON(requestParameters['createSeasonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateSeasonResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new season
     * Creates a new season
     */
    async apiSeasonsPost(requestParameters: ApiSeasonsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateSeasonResponse> {
        const response = await this.apiSeasonsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update season
     */
    async apiSeasonsPutRaw(requestParameters: ApiSeasonsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateSeasonRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSeasonRequest',
                'Required parameter "updateSeasonRequest" was null or undefined when calling apiSeasonsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSeasonRequestToJSON(requestParameters['updateSeasonRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update season
     */
    async apiSeasonsPut(requestParameters: ApiSeasonsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSeasonsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all seasons
     */
    async apiSeasonsScrollGetRaw(requestParameters: ApiSeasonsScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetSeasonResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetSeasonResponseFromJSON(jsonValue));
    }

    /**
     * Get all seasons
     */
    async apiSeasonsScrollGet(requestParameters: ApiSeasonsScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetSeasonResponse> {
        const response = await this.apiSeasonsScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search seasons
     */
    async apiSeasonsSearchPostRaw(requestParameters: ApiSeasonsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetSeasonResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetSeasonResponseFromJSON(jsonValue));
    }

    /**
     * Search seasons
     */
    async apiSeasonsSearchPost(requestParameters: ApiSeasonsSearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetSeasonResponse> {
        const response = await this.apiSeasonsSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the discounts associated with a specific season.
     * Update season discounts
     */
    async apiSeasonsSeasonIdDiscountsPutRaw(requestParameters: ApiSeasonsSeasonIdDiscountsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['seasonId'] == null) {
            throw new runtime.RequiredError(
                'seasonId',
                'Required parameter "seasonId" was null or undefined when calling apiSeasonsSeasonIdDiscountsPut().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling apiSeasonsSeasonIdDiscountsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons/{seasonId}/discounts`;
        urlPath = urlPath.replace(`{${"seasonId"}}`, encodeURIComponent(String(requestParameters['seasonId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the discounts associated with a specific season.
     * Update season discounts
     */
    async apiSeasonsSeasonIdDiscountsPut(requestParameters: ApiSeasonsSeasonIdDiscountsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSeasonsSeasonIdDiscountsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get season
     */
    async getSeasonByIdRaw(requestParameters: GetSeasonByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSeasonResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSeasonById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/seasons/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSeasonResponseFromJSON(jsonValue));
    }

    /**
     * Get season
     */
    async getSeasonById(requestParameters: GetSeasonByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSeasonResponse> {
        const response = await this.getSeasonByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
